import { FuelTypography } from '@frete.com/fuel-react';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import { textConstants } from 'constants/texts';
import React, { FC } from 'react';

const TimeSinceCreated: FC<{ timeSinceCreated: string; registrationDate: string }> = ({
  timeSinceCreated,
  registrationDate,
}) => {
  const { noInfoText } = textConstants;

  return (
    <GenericInfoItem title="Tempo na Fretebras">
      {timeSinceCreated ? (
        <>
          <FuelTypography weight="medium" data-testid="test-time-since-created">
            {timeSinceCreated}
          </FuelTypography>
          {registrationDate && (
            <FuelTypography size="caption" color="neutral-default" weight="medium" data-testid="test-registration-date">
              {registrationDate}
            </FuelTypography>
          )}
        </>
      ) : (
        <FuelTypography weight="medium" data-testid="test-empty-state">
          {noInfoText}
        </FuelTypography>
      )}
    </GenericInfoItem>
  );
};

export default TimeSinceCreated;
